import React, { useEffect, useState } from "react";
import { Auth, Hub } from "aws-amplify";
import { Grid, Paper } from "@material-ui/core";
import MantraAppBar from "./components/MantraAppBar";
import TaxDocumentsView from "./components/TaxDocumentsView";
import PreviousTaxDocumentsView from "./components/PreviousTaxDocumentsView";

import "./App.css";

export const UserContext = React.createContext({
  user: null,
  setUser: () => {},
  signOutState: false,
  setSignOutState: () => {},
  taxReturn: null,
  setTaxReturn: () => {},
});

const App = (props) => {
  const [user, setUser] = useState();
  const [signOutState, setSignOutState] = useState(false);
  const [taxReturn, setTaxReturn] = useState();
  const value = {
    user,
    setUser,
    signOutState,
    setSignOutState,
    taxReturn,
    setTaxReturn,
  };

  useEffect(() => {
    console.log("Inside Authorization useEffect");

    Hub.listen("auth", ({ payload: { event, data } }) => {
      console.log("Auth Event:", event);
      switch (event) {
        case "signIn":
          break;
        case "cognitoHostedUI":
          //getUser().then((userData) => setUser(userData));
          break;
        case "signOut":
          console.log("Signing out");
          setUser(null);
          Auth.federatedSignIn();
          break;
        case "signIn_failure":
        case "cognitoHostedUI_failure":
          console.log("Sign in failure", data);
          break;
        default:
          break;
      }
    });
    console.log("Inside useEffect signOutState: " + signOutState);
    if (!user) {
      getUser().then((userData) => setUser(userData));
      console.log("userData", user);
    }
    async function getUser() {
      console.log("Inside getUser call signOutState: " + signOutState);
      if (!signOutState) {
        setSignOutState(false);
        try {
          let userData = await Auth.currentAuthenticatedUser();
          return userData;
        } catch (err) {
          if (err === "The user is not authenticated") {
            await Auth.federatedSignIn();
          }
          console.log("User login error:", err);
          return null;
        }
      }
    }
  }, [user, signOutState]);

  /*
  <Grid item sm={5}>
              <Paper>{<PreviousYearAttachment />}</Paper>
            </Grid>
            <Grid item sm={5}>
              <Paper>{<PreviousYearAttachment />}</Paper>
            </Grid>
  */
  return (
    <div>
      {user ? (
        <UserContext.Provider value={value}>
          <Grid container spacing={2} justify="space-around">
            <Grid item sm={12}>
              <MantraAppBar />
            </Grid>
            <Grid item sm={5}>
              <Paper>
                <TaxDocumentsView taxDocumentType={"Current Year"} />
              </Paper>
            </Grid>
            <Grid item sm={5}>
              <Paper>
                <PreviousTaxDocumentsView taxDocumentType={"Previous Year"} />
              </Paper>
            </Grid>
          </Grid>
        </UserContext.Provider>
      ) : (
        <div>...</div>
      )}
    </div>
  );

  /*  return !user ? (
    <AmplifyAuthenticator />
  ) : (
    <MantraTaxContext.Provider value={value}>
      <Grid container spacing={2} justify="space-around">
        <Grid item sm={12}>
          {<MantraAppBar />}
        </Grid>
        <Grid item sm={5}>
          <Paper>{<PreviousYearAttachment />}</Paper>
        </Grid>
        <Grid item sm={5}>
          <Paper>{<PreviousYearAttachment />}</Paper>
        </Grid>
      </Grid>
    </MantraTaxContext.Provider>
  );*/
};
export default App;
